/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {
  getNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
  setNDCDetails,
  setNDCDetailsTableRowSelected,
  setNDCErrorPopupMessage,
  setNDCLoading,
} from '../../store/action';
import { NDC_DRUG_TABLEHAD } from '../../utility/tableHeads';
import NDCColumnCustomComponent from '../NDCColumnCustomComponent';
import Grid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import ViewHistoryComponent from '../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import CommonModal from '../../../../../SharedModules/Dialog/CommonModal';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';



const NDCViewDetailsTable = ({
  showFullScreen = true,
  fullScreen,
  setFullScreen,
  isViewNDCHidden,
}) => {
  const history = useHistory();

  const dispatch = useDispatch();
  const ndcDetailsTableData = useSelector(
    (state) => state.sharedState.ndc.ndcDetailsTableData
  );
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [tableCount, setTableCount] = useState(0);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const [confirmAction, setConfirmAction] = React.useState(false);
  const [custPayload, setCustPayload] = React.useState();

  const navigateToNDCDetailsPage = () => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === '/ndc-details') === -1) {
      updateTabs.push({
        navTo: '/ndc-details',
        value: 'NDC Details',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: '/ndc-details',
    });
  };
const callNdcApi = async (data) => {
   if (ndcDetailsTableData.length > 0) {
      dispatch(setNDCLoading(true));
      const response = await getNDCDetails([ndcDetailsTableData[0]]);
      dispatch(setNDCLoading(false));
      if (response) {
        dispatch(setNDCErrorPopupMessage(null));
        dispatch(setCurrentNDCDetailsIndex(1));
        dispatch(setCurrentNDCDetailsSelected(response[0],'All'));
        dispatch(setNDCDetails(ndcDetailsTableData));
        navigateToNDCDetailsPage();
      } else {
        dispatch(setNDCErrorPopupMessage('Something went wrong.'));
      }
    } else {
      dispatch(setNDCErrorPopupMessage('At least one NDC must be selected.'));
    }
};
 const handleViewDetailsClick = async () => {
    if (ndcDetailsTableData.length > 1000) {
      setConfirmAction(true);
    }
    if (ndcDetailsTableData.length < 1000) {
      setConfirmAction(false);
      dispatch(setNDCLoading(true));
      const response = await getNDCDetails([ndcDetailsTableData[0]]);
      dispatch(setNDCLoading(false));
      if (response) {
        dispatch(setNDCErrorPopupMessage(null));
        dispatch(setCurrentNDCDetailsIndex(1));
        dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
        dispatch(setNDCDetails(ndcDetailsTableData));
        navigateToNDCDetailsPage();
      } else {
        dispatch(setNDCErrorPopupMessage('Something went wrong.'));
      }
    } else {
      dispatch(setNDCErrorPopupMessage('At least one NDC must be selected.'));
    }
 };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);
  useEffect(() => {

    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, ndcDetailsTableData]);
  

  const onSelectionChanged = useCallback(() => {
    dispatch(setNDCDetailsTableRowSelected(gridApi.getSelectedRows()));
  }, [gridApi]);

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({});
  };

  const handleFullScreenViewClick = () => {
    setFullScreen(!fullScreen);
  };

  return (
    <>
      <div
        className={`d-flex align-items-center justify-content-end ${
          isViewNDCHidden ? 'invisible' : ''
        }`}
      >
        {!fullScreen && (
          <>
            <Button
              className="btn btn-success btn-view"
              onClick={() => handleViewDetailsClick()}
            >
              <SVGComponent iconName="Icon-view" />
              View NDC Detail
            </Button>{' '}
          </>
        )}
      </div>
      <div className="table-container eightRecords frr-tbl-with-feature">
        <Grid
          gridHeight={fullScreen ? '100vh' : 350}
          rowData={ndcDetailsTableData}
          fullScreenView={fullScreen}
          columnDefs={NDC_DRUG_TABLEHAD}
          data-testid="onEditingStopped"
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          singleClickEdit={false}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          handleFullScreenViewClick={handleFullScreenViewClick}
          exportFile
          fileName="View Calc Interest - NDC"
          defaultCol={{ editable: false }}
          onGridReady={onGridReady}
          rowSelection="multiple"
          onSelectionChanged={onSelectionChanged}
          frameworkComponents={{
            ndcComponent: NDCColumnCustomComponent,
            nameRenderNdcDrugName: (cellInfo) => {
              const name = cellInfo.data && cellInfo.data.drugName;
              if (name && name.length > 15) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
          }}
        />
        {showViewHistory && (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="DRUG"
            keyValue={keyValue}
          />
        )}
      </div>
       <CommonModal
        open={confirmAction}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => {
          setConfirmAction(false);
          callNdcApi(ndcDetailsTableData);
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setConfirmAction(false)}
        modalTitle="Confirmation Dialog"
        childrenComponent={constantMessageData.NDC_LIMIT_TO_1000}
      />
    </>
  );
};

export default NDCViewDetailsTable;
